
import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Routes, Route, BrowserRouter, Outlet } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './style/pfapp.scss';
import "@fortawesome/fontawesome-free/css/all.min.css"
import { PrivateRoute } from './routes/privateRoute';
import NotValidTab from './pages/NetworkWbSite/NotValidTab';
import NetworkWbSite from './pages/NetworkWbSite';

const App = () => {
  const [modules, setModules] = useState([])

  const rendernetwork = () => {

    return (<Route path='/' element={<NetworkWbSite module={module[0]} />} />)
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Outlet />}>
            <Route element={<PrivateRoute modules={modules} />}>
              {rendernetwork()}
            </Route>
            <Route path='*' element={<NotValidTab />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer position='top-right' autoClose={8084} />
    </>
  );
};

export default App;

